import VueSegmentAnalytics from 'vue-segment-analytics';

const trackNamesMap = {
	autoInterest: 'Auto_interest',
	autoLead: 'Auto_lead',
	conversion: 'Conversion',
	conversionAbandon: 'Conversion_Abandon',
	clickPhone: 'Conversion_Calls',
	editPhone: 'Edit_number',
	resend: 'Resend_code',
	textVerify: 'Text_verify',
	textVerified: 'Text_verified',
};

function install(Vue, options = {}) {
	const config = {
		debug: window.location.search.indexOf('external') !== -1
				|| process.env.VUE_APP_DEBUG === 'true'
				|| Vue.$iUtils.isWebCrawler,
		id: process.env.VUE_APP_ANALYTICS_SEGMENT,
	};

	const segmentOptions = { ...config, ...options };

	Vue.use(VueSegmentAnalytics, segmentOptions);

	const analytics = {
		...Vue.$segment,
		identify(id, payload = {}) {
			Vue.$log.info(id, payload);

			// if (window.analytics) {
			// 	window.analytics.identify(id, payload, {
			// 		integrations: { FullStory: true },
			// 	});
			// }

			Vue.$segment.identify(id, payload);
		},

		page(name, payload = {}) {
			// if (window.analytics) {
			// 	window.analytics.page(name, payload);
			// }

			Vue.$segment.page(name, payload);
		},

		track(name, payload = {}) {
			// if (window.analytics) {
			// 	window.analytics.track(trackNamesMap[name], payload);
			// }

			Vue.$segment.track(trackNamesMap[name], payload);
		},
	};

	// Setup instance access
	/* eslint-disable accessor-pairs */
	Object.defineProperty(Vue, '$analytics', {
		get() {
			return analytics;
		},
	});
	Object.defineProperty(Vue.prototype, '$analytics', {
		get() {
			return analytics;
		},
	});
	/* eslint-enable accessor-pairs */
}

export default { install };
